
import { ParallaxEffect, ParallaxContext } from '../ParallaxEffect';
import { BaseParallaxEffect } from '../BaseParallaxEffect';

export class CosmicBackgroundEffect extends BaseParallaxEffect implements ParallaxEffect {
    public render(pc: ParallaxContext): void {
        const { ctx, layerIndex, config, time, width, height } = pc;
         const spacing = (120 + layerIndex * 60) / (config.parallaxPatternDensity || 1.0);
        const { x1, x2, y1, y2 } = this.getGridBounds(pc, spacing );
        const scale = config.parallaxScale || 1.0;
        const curTime = time * config.parallaxSpeed;

        ctx.fillStyle = pc.color;

        const draw = () => {
            for (let x = x1; x <= x2; x += spacing) {
                for (let y = y1; y <= y2; y += spacing) {
                    const noise = Math.sin(x * 0.005 + curTime) * Math.cos(y * 0.005 + curTime);
                    const r = (5 + noise * 5) * scale;
                    
                    ctx.save();
                    ctx.globalAlpha = (0.2 + noise * 0.2) / (layerIndex + 1);
                    ctx.beginPath();
                    ctx.arc(x, y, r, 0, Math.PI * 2);
                    ctx.fill();
                    ctx.restore();
                }
            }
        };

        draw();
        this.applyGlow(pc, draw);
    }
}
